import {horsesConstants} from "../reducers/horses/horsesConstants";
import {tableConstants} from "../reducers/table/tableConstants";

export const depositMoney = (amount) => {
    return (dispatch) => {
        dispatch({
            type: "deposit",
            payload: amount
        });
    }
}


export const withdrawMoney = (amount) => {
    console.log(amount, "Lol")
    return (dispatch) => {
        dispatch({
            type: "withdraw",
            payload: amount
        });
    }
}

export const alertMessage = (msg, type) => {
    return (dispatch) => {
        dispatch({
            type: type ? type : "ALERT_CLEAR",
            message: msg
        });
    }
}

export const loadingAction = (type) => {
    return (dispatch) => {
        dispatch({
            type: type ? type : "LOADING_ERROR"
        });
    }
}

export const loadingProgress = (type, progress) => {
    return (dispatch) => {
        dispatch({
            type: type ? type : "LOADING_PROGRESS",
            progress: progress
        });
    }
}

export const changeHorsesSearch = (search) => {
    return (dispatch) => {
        dispatch({
            type: horsesConstants.CHANGE_SEARCH,
            payload: search
        });
    }
}

export const clearHorsesSearch = () => {
    return (dispatch) => {
        dispatch({
            type: horsesConstants.CLEAR_SEARCH
        });
    }
}

export const setHorsesFilters = (filters) => {
    return (dispatch) => {
        dispatch({
            type: horsesConstants.SET_FILTERS,
            payload: filters
        });
    }
}

export const clearHorsesFilters = () => {
    return (dispatch) => {
        dispatch({
            type: horsesConstants.CLEAR_FILTERS
        });
    }
}

export const updateHorsesFilter = (name, filterData) => {
    return (dispatch) => {
        dispatch({
            type: horsesConstants.UPDATE_FILTER,
            payload: { name, filterData }
        });
    }
}

export const setTableConfig = (tableId, config) => {
    return (dispatch) => {
        dispatch({
            type: tableConstants.SET_TABLE_CONFIG,
            payload: { tableId, config }
        });
    }
}

export const updateTableConfig = (tableId, config) => {
    return (dispatch) => {
        dispatch({
            type: tableConstants.UPDATE_TABLE_CONFIG,
            payload: { tableId, config }
        });
    }
}

